import { render } from "./dataPanel.vue?vue&type=template&id=2302f708&scoped=true"
import script from "./dataPanel.vue?vue&type=script&lang=js"
export * from "./dataPanel.vue?vue&type=script&lang=js"

import "./dataPanel.vue?vue&type=style&index=0&id=2302f708&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2302f708"]])

export default __exports__